export default __webpack_public_path__ + "static/02_WillyTheCocoa-858e98f3395b15a413cfa8fb7420ab32.pdf";